import styled from 'styled-components';

export const Container = styled.div`
  .card {
    max-width: 800px;
  }
`;
